import { environment } from '../../environments/environment';

// The public site for the active network. Mainnet and testnet ship from different hosts,
// and each network's faucet only drips for its own.
const DEPLOY_HOSTS =
  environment.network === 'mainnet' ? ['stomp.gg', 'www.stomp.gg'] : ['test.stomp.gg'];

// Local dev and preview builds are never the deployed site, so they never auto-drip.
export function isDeployedSite(): boolean {
  return DEPLOY_HOSTS.includes(window.location.hostname);
}
